const SAMPLE_DATA_LAURA_LES = [
  {
    "id": "dress",
    "data": [
      {
        "x": "2016",
        "y": 0
      },
      {
        "x": "2017",
        "y": 2
      },
      {
        "x": "2018",
        "y": 0
      }
    ]
  },
  {
    "id": "human",
    "data": [
      {
        "x": "2016",
        "y": 0
      },
      {
        "x": "2017",
        "y": 4
      },
      {
        "x": "2018",
        "y": 0
      }
    ]
  },
  {
    "id": "like",
    "data": [
      {
        "x": "2016",
        "y": 1
      },
      {
        "x": "2017",
        "y": 18
      },
      {
        "x": "2018",
        "y": 6
      }
    ]
  },
  {
    "id": "skirt",
    "data": [
      {
        "x": "2016",
        "y": 0
      },
      {
        "x": "2017",
        "y": 4
      },
      {
        "x": "2018",
        "y": 0
      }
    ]
  },
  {
    "id": "like",
    "data": [
      {
        "x": "2016",
        "y": 1
      },
      {
        "x": "2017",
        "y": 18
      },
      {
        "x": "2018",
        "y": 6
      }
    ]
  }
]

export const SAMPLE_LINE_DATA = [
  {
    id: "really long key name lol",
    color: "hsl(247, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 73,
      },
      {
        x: "helicopter",
        y: 206,
      },
      {
        x: "boat",
        y: 261,
      },
      {
        x: "train",
        y: 32,
      },
      {
        x: "subway",
        y: 207,
      },
      {
        x: "bus",
        y: 23,
      },
      {
        x: "car",
        y: 83,
      },
      {
        x: "moto",
        y: 275,
      },
      {
        x: "bicycle",
        y: 60,
      },
      {
        x: "horse",
        y: 100,
      },
      {
        x: "skateboard",
        y: 100,
      },
      {
        x: "others",
        y: 187,
      },
    ],
  },
  {
    id: "france",
    color: "hsl(117, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 185,
      },
      {
        x: "helicopter",
        y: 153,
      },
      {
        x: "boat",
        y: 217,
      },
      {
        x: "train",
        y: 259,
      },
      {
        x: "subway",
        y: 181,
      },
      {
        x: "bus",
        y: 91,
      },
      {
        x: "car",
        y: 296,
      },
      {
        x: "moto",
        y: 202,
      },
      {
        x: "bicycle",
        y: 216,
      },
      {
        x: "horse",
        y: 120,
      },
      {
        x: "skateboard",
        y: 260,
      },
      {
        x: "others",
        y: 185,
      },
    ],
  },
  {
    id: "us",
    color: "hsl(22, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 66,
      },
      {
        x: "helicopter",
        y: 220,
      },
      {
        x: "boat",
        y: 221,
      },
      {
        x: "train",
        y: 268,
      },
      {
        x: "subway",
        y: 20,
      },
      {
        x: "bus",
        y: 97,
      },
      {
        x: "car",
        y: 299,
      },
      {
        x: "moto",
        y: 126,
      },
      {
        x: "bicycle",
        y: 237,
      },
      {
        x: "horse",
        y: 57,
      },
      {
        x: "skateboard",
        y: 113,
      },
      {
        x: "others",
        y: 53,
      },
    ],
  },
  {
    id: "germany",
    color: "hsl(301, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 178,
      },
      {
        x: "helicopter",
        y: 250,
      },
      {
        x: "boat",
        y: 22,
      },
      {
        x: "train",
        y: 159,
      },
      {
        x: "subway",
        y: 61,
      },
      {
        x: "bus",
        y: 133,
      },
      {
        x: "car",
        y: 46,
      },
      {
        x: "moto",
        y: 142,
      },
      {
        x: "bicycle",
        y: 29,
      },
      {
        x: "horse",
        y: 267,
      },
      {
        x: "skateboard",
        y: 284,
      },
      {
        x: "others",
        y: 26,
      },
    ],
  },
  {
    id: "norway",
    color: "hsl(356, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 156,
      },
      {
        x: "helicopter",
        y: 280,
      },
      {
        x: "boat",
        y: 89,
      },
      {
        x: "train",
        y: 235,
      },
      {
        x: "subway",
        y: 110,
      },
      {
        x: "bus",
        y: 289,
      },
      {
        x: "car",
        y: 250,
      },
      {
        x: "moto",
        y: 171,
      },
      {
        x: "bicycle",
        y: 248,
      },
      {
        x: "horse",
        y: 280,
      },
      {
        x: "skateboard",
        y: 61,
      },
      {
        x: "others",
        y: 106,
      },
    ],
  },
]

export const SAMPLE_BAR_DATA = [
  {
    country: "AD",
    "hot dog": 4,
    "hot dogColor": "hsl(286, 70%, 50%)",
    burger: 56,
    burgerColor: "hsl(113, 70%, 50%)",
    sandwich: 198,
    sandwichColor: "hsl(255, 70%, 50%)",
    kebab: 139,
    kebabColor: "hsl(230, 70%, 50%)",
    fries: 8,
    friesColor: "hsl(339, 70%, 50%)",
    donut: 125,
    donutColor: "hsl(112, 70%, 50%)",
  },
  {
    country: "AE",
    "hot dog": 188,
    "hot dogColor": "hsl(213, 70%, 50%)",
    burger: 155,
    burgerColor: "hsl(111, 70%, 50%)",
    sandwich: 167,
    sandwichColor: "hsl(108, 70%, 50%)",
    kebab: 90,
    kebabColor: "hsl(101, 70%, 50%)",
    fries: 161,
    friesColor: "hsl(216, 70%, 50%)",
    donut: 53,
    donutColor: "hsl(303, 70%, 50%)",
  },
  {
    country: "AF",
    "hot dog": 48,
    "hot dogColor": "hsl(340, 70%, 50%)",
    burger: 139,
    burgerColor: "hsl(121, 70%, 50%)",
    sandwich: 82,
    sandwichColor: "hsl(8, 70%, 50%)",
    kebab: 153,
    kebabColor: "hsl(133, 70%, 50%)",
    fries: 99,
    friesColor: "hsl(257, 70%, 50%)",
    donut: 7,
    donutColor: "hsl(243, 70%, 50%)",
  },
]
